import { API_BASE_URL } from "@/api/api.config";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";

/**
 * Lazy called function to get grade groups for console settings
 */
const useLazyContentSettingsGroupsGet = (data) => {
  const includeArchived = data?.include_archived || false;
  const requestUrl = `${API_BASE_URL}/api/v3/visibility/content-settings-groups/?include_archived=${includeArchived}`;
  return useLazyRestQuery(requestUrl);
};

export default useLazyContentSettingsGroupsGet;
